import * as Yup from "yup";

const getAdminAdjustmentSchema = (requireReason) =>
  Yup.object().shape({
    reason: Yup.string()
      .label("Reason")
      .max(1000)
      .when([], {
        is: () => requireReason,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    reference_id: Yup.string()
      .label("Reference ID")
      .max(100)
      .optional(),
    attachments: Yup.mixed()
      .label("Attachments")
      .optional(),
  });

export default getAdminAdjustmentSchema;
